import { render, staticRenderFns } from "./createUserCataloge.vue?vue&type=template&id=6edb7cff&scoped=true"
import script from "./createUserCataloge.vue?vue&type=script&lang=js"
export * from "./createUserCataloge.vue?vue&type=script&lang=js"
import style0 from "./createUserCataloge.vue?vue&type=style&index=0&id=6edb7cff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb7cff",
  null
  
)

export default component.exports